import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';

export const BankImagesGrid = styled.div`
  display: grid;
  grid-template-columns: 120px 120px 120px 120px 120px;
  grid-auto-rows: 64px;
  grid-gap: 16px;
  justify-content: center;
  height: 170px;
`;

export const BankImageCell = styled.div`
  display: grid;
  align-items: center;
  justify-items: center;
`;

export const useStyles = makeStyles((theme) => ({
  addNonConnectedAccount: {
    color: theme.palette.greyScale[2],
    position: 'absolute',
    bottom: 0,
    padding: 8,
  },
  cancelButton: {
    marginRight: 20,
    marginBottom: 10,
  },
  doMoreQuicken: {
    margin: `0 0 ${theme.spacing(3)}px ${theme.spacing(3)}px`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  doMoreQuickenButton: {

  },
  addNonConnectedAccountQuicken: {
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(),
    color: theme.palette.greyScale[2],
  },
  dropDown: {
    maxHeight: '320px',
    overflow: 'scroll',
  },
  manualButton: {
    textTransform: 'none',
    textDecoration: 'underline',
    fontSize: 14,
    padding: 0,
    fontWeight: 400,
    '&:hover': {
      textDecoration: 'none',
    },
  },
  popularButton: {
    border: 'none',
    padding: 0,
    borderRadius: 7,
    '&:hover': {
      border: '1px solid #4D96EF',
      boxShadow: '0 0 4px #4D96EF',
    },
  },
  progress: {
    display: 'block',
    margin: '0 auto',
  },
  root: {
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
    margin: '24px',
    position: 'relative',
  },
  searchBar: {
    borderRadius: 3,
    boxShadow: `1px 2px 5px -2px ${theme.applyOpacityToHex(theme.palette.greyScale[0], 0.3)}`,
  },
  statusContainer: {
    minHeight: '200px',
  },
  subTitle: {
    marginTop: -5,
    paddingBottom: 8,
    color: theme.palette.greyScale[2],
  },
  popularCopy: {
    padding: '12px 0',
    color: theme.palette.greyScale[2],
  },
}));
